import { render, staticRenderFns } from "./projectAuth.vue?vue&type=template&id=28564597&scoped=true&"
import script from "./projectAuth.vue?vue&type=script&lang=js&"
export * from "./projectAuth.vue?vue&type=script&lang=js&"
import style0 from "./projectAuth.vue?vue&type=style&index=0&id=28564597&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28564597",
  null
  
)

export default component.exports